import styled, { css, RuleSet } from "styled-components";
import { Table } from "antd";
import { greyText, lightGreys, tableStyles } from "../../styles";
import { pulse } from "../containers/styledComponents";
import { compassLightGreen } from "../../styles";

export const TableContainer = styled.div<{ p?: string }>`
  width: 100%;
  padding: ${({ p }): string => p || "10px 50px 20px 0"};

  // Hide fixed column shadows on the right
  :where(.css-dev-only-do-not-override-98ntnt).ant-table-wrapper
    .ant-table-ping-right
    .ant-table-cell-fix-right-first::after,
  :where(.css-dev-only-do-not-override-98ntnt).ant-table-wrapper
    .ant-table-ping-right
    .ant-table-cell-fix-right-last::after {
    box-shadow: none;
  }
`;

const getLoadingAnimationStyles = (isLoading: boolean): RuleSet | "" => {
  return isLoading
    ? css`
        background-color: #d3d3d3;
        animation: ${pulse} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      `
    : "";
};

export const StyledTable = styled(Table)<{
  isLoading?: boolean;
  hasEveryCellBorderBottom?: boolean;
}>`
  .ant-table {
    width: 100%;
    border: none;
    border-radius: 12px;
    padding: 10px 0;
    ${({ isLoading }): "" | RuleSet =>
      getLoadingAnimationStyles(isLoading || false)}
  }

  .ant-table-thead > tr > th {
    color: ${greyText};
    background-color: white;
    font-family: "Apercu", sans-serif;
    font-size: 13px;
    font-weight: 400;
    padding: 15px 10px 15px 30px !important;
    ${({ isLoading }): "" | RuleSet =>
      getLoadingAnimationStyles(isLoading || false)}
  }

  .ant-table-tbody > tr:hover > td {
    background: ${lightGreys.KPIBackground} !important;
  }

  .ant-table-tbody > tr > td {
    background-color: #fff;
    color: #333;
    font-family: "Arial", sans-serif;
    font-size: 14px;
    ${({ isLoading }): "" | RuleSet =>
      getLoadingAnimationStyles(isLoading || false)}
  }

  .ant-table-tbody > tr:nth-child(odd) > td {
    border-bottom: 2px solid ${tableStyles.colors.border};
  }

  ${({ hasEveryCellBorderBottom }): false | RuleSet<object> | undefined =>
    hasEveryCellBorderBottom &&
    css`
      .ant-table-tbody > tr > td {
        border-bottom: 2px solid ${tableStyles.colors.border} !important;
      }
      .ant-table-thead > tr > th {
        padding: 5px 5px 5px 30px !important;
      }
    `}

  .ant-table-tbody > tr:nth-child(even) > td {
    border-bottom: none;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #e6f7ff;
  }

  td.ant-table-cell {
    width: fit-content;
    min-width: 150px !important;
    max-width: 350px !important;
    padding: 5px 15px !important;
  }

  .ant-pagination-item {
    border: none;
    background: transparent;
    margin-right: 1px;
  }

  .ant-pagination-item-active {
    background: #21383e;
    color: white;
  }

  .ant-table-column-sorter-down.active {
    color: ${compassLightGreen} !important;
  }
  .ant-table-column-sorter-up.active {
    color: ${compassLightGreen} !important;
  }

  .ant-table-thead > tr > th:hover {
    background-color: white;
  }

  .ant-table-column-has-sorters {
    border-radius: 6px 6px 0 0;
  }

  /* Global stylesheet or CSS module */
  .ant-pagination-total-text {
    margin-top: 1px;
    font-size: 13px;
    color: ${greyText}; /* Change to whatever color you prefer */
    padding-right: 10px; /* Adds some space to the right of the text */
    font-family: "Apercu";
  }

  .ant-table-row-expand-icon {
    background-color: white !important; /* Change background color */
    color: ${compassLightGreen} !important; /* Change icon color */
  }

  .ant-table-row-expand-icon-expanded {
    background-color: ${compassLightGreen} !important; /* Change background for expanded state */
    color: white !important;
  }

  .ant-table-row-expand-icon:hover {
    background-color: ${compassLightGreen} !important; /* Darker blue on hover */
    color: white !important;
  }
`;
